angular.module("ainapp")
    .controller("LinkReportController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Link Report";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Init = function () {

                $scope.filter = {
                    Keyword: ""
                }
            }
            $scope.Init();

            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        o.data.Keyword = $scope.filter.Keyword;
                    
                        MainService.LinkReport(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            VoucherNo: {
                                type: "string",
                                editable: false,
                            },
                            VoucherType: {
                                type: "string",
                                editable: false,
                            },
                            LinkedQty: {
                                type: "number",
                                editable: false,
                            },
                            LinkedVoucherNo: {
                                type: "string",
                                editable: false,
                            },
                            LinkedVoucherType: {
                                type: "string",
                                editable: false,
                            },
                            "Product.Name": {
                                type: "string",
                                editable: false,
                            },
                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 700,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },



                columns: [
                    {
                        field: "Product.Name",
                        title: "Product",
                        },
                    {
                        field: "VoucherNo",
                        title: "Voucher",
                        },
                    {
                        field: "VoucherType",
                        title: "Type",
                        },
                    {
                        field: "LinkedQty",
                        title: "Qty",
                        },
                    {
                        field: "LinkedVoucherNo",
                        title: "Linked Voucher No",
                        },
                    {
                        field: "LinkedVoucherType",
                        title: "Linked Voucher Type",
                    }
                    ],
            };


            $scope.SearchKendo = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.refresh = function () {
                $scope.Init();
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }


        }])
